import styled from '@emotion/styled';
import { Trans, useTranslation } from 'next-i18next';
import appConfig from 'app-config';
import IcBrandAppleSolid from 'src/assets/images/icBrandAppleSolid.svg';
import IcBrandFacebook from 'src/assets/images/icBrandFacebook.svg';
import IcBrandGoogle from 'src/assets/images/icBrandGoogle.svg';
import ExternalLink from 'src/components/ExternalLink';
import LoginApple from 'src/components/LoginApple';
import LoginFacebook from 'src/components/LoginFacebook';
import LoginGoogle from 'src/components/LoginGoogle';
import VividiLogoBase from 'src/components/VividiOnly/Logo';
import { LoginBrandName } from 'src/types/Login';
import { setTargetBlankToLinks } from 'src/utils/html';
import LoginButton from './Button';
const LOGIN_BUTTON_MAP = {
  apple: {
    brand: LoginBrandName.APPLE,
    provider: LoginApple,
    icon: IcBrandAppleSolid,
    label: 'Connect with Apple'
  },
  google: {
    brand: LoginBrandName.GOOGLE,
    provider: LoginGoogle,
    icon: IcBrandGoogle,
    label: 'Connect with Google'
  },
  facebook: {
    brand: LoginBrandName.FACEBOOK,
    provider: LoginFacebook,
    icon: IcBrandFacebook,
    label: 'Connect with Facebook'
  },
  phone: null
} as const;
const Container = styled.div`
  padding: 24px;

  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: start;
  gap: 20px;
`;
const Logo = styled(VividiLogoBase)`
  place-self: center;

  width: 104px;
  height: 30px;

  margin-block-end: 16px;

  ${({
  theme
}) => theme.screenSize.tablet} {
    margin-block-start: 6px;
  }
`;
const TitleContainer = styled.div`
  flex: 1;

  display: flex;
  align-items: center;
  justify-content: center;
`;
const Title = styled.h1`
  margin: 0 0 4px;

  font-size: 30px;
  font-weight: 900;
  white-space: pre-wrap;

  color: ${({
  theme
}) => theme.color.content12};

  text-align: center;
`;
const Emphasize = styled.em`
  font-style: normal;
  color: ${({
  theme
}) => theme.color.accentC1};
`;
const NoticeText = styled.p`
  padding: 0 16px;

  font-size: 10px;
  font-weight: 400;
  text-align: center;
  white-space: pre-wrap;

  color: ${({
  theme
}) => theme.color.content7};

  > a {
    color: inherit;
    font-weight: 600;
    text-decoration: underline;

    :visited {
      color: inherit;
    }
  }
`;
const ButtonGroup = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  gap: 10px;
`;
const ContactContainer = styled.div`
  box-sizing: content-box;

  margin-block-start: -4px;

  height: 32px;
  padding: 16px 24px 0px;

  font-size: 10px;
  font-weight: 400;

  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  color: ${({
  theme
}) => theme.color.content8};

  ${({
  theme
}) => theme.screenSize.desktop} {
    font-size: 12px;
  }
`;
const Contact = styled(ExternalLink)`
  all: unset;
  cursor: pointer;

  font-weight: 700;
`;
const VividiLoginEntry = (props: {
  className?: string;
}) => {
  const {
    t
  } = useTranslation();
  return <Container {...props} data-sentry-element="Container" data-sentry-component="VividiLoginEntry" data-sentry-source-file="LoginEntry.tsx">
      <Logo data-sentry-element="Logo" data-sentry-source-file="LoginEntry.tsx" />
      <TitleContainer data-sentry-element="TitleContainer" data-sentry-source-file="LoginEntry.tsx">
        <Title data-sentry-element="Title" data-sentry-source-file="LoginEntry.tsx">
          <Trans i18nKey={t('vividi_catchphrase')}
        /* eslint-disable react/jsx-key */ components={[<Emphasize />]}
        /* eslint-disable react/jsx-key */ data-sentry-element="Trans" data-sentry-source-file="LoginEntry.tsx" />
        </Title>
      </TitleContainer>
      <NoticeText dangerouslySetInnerHTML={{
      __html: setTargetBlankToLinks(t('vividi_onboarding_consent'))
    }} data-sentry-element="NoticeText" data-sentry-source-file="LoginEntry.tsx" />
      <ButtonGroup data-sentry-element="ButtonGroup" data-sentry-source-file="LoginEntry.tsx">
        {appConfig.availableLoginMethods.map(loginMethod => {
        const buttonProps = LOGIN_BUTTON_MAP[loginMethod];
        if (buttonProps == null) return null;
        const {
          provider: Provider,
          ...restProps
        } = buttonProps;
        return <Provider key={loginMethod} render={({
          onClick
        }) => <LoginButton {...restProps} onClick={onClick} />} />;
      })}
      </ButtonGroup>
      <ContactContainer data-sentry-element="ContactContainer" data-sentry-source-file="LoginEntry.tsx">
        <span>{t('vividi_login_help')}</span>
        <Contact href='https://help.vividi.com/hc/articles/47233484723097' data-sentry-element="Contact" data-sentry-source-file="LoginEntry.tsx">
          {t('LOGIN__CONTACT_US')}
        </Contact>
      </ContactContainer>
    </Container>;
};
export default VividiLoginEntry;